

import { motion } from "motion/react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

export const PricingSection = () => {
  return (
    <section className="py-32 relative overflow-hidden bg-brand-secondary/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-6xl font-display font-bold tracking-tight mb-6">Simple, Outcome-Based Pricing</h2>
            <p className="text-xl text-brand-muted font-bold italic opacity-60">Pay only when you hire. Choose the level of support you need.</p>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            whileHover={{ y: -10 }}
            className="p-12 bg-white rounded-[3rem] border border-gray-100 shadow-xl"
          >
            <h3 className="text-2xl font-display font-bold text-brand-primary mb-4">AI Matched & Vetted Candidates</h3>
            <p className="text-brand-muted mb-8 text-lg">AI-powered matching and automated candidate vetting to help you hire faster.</p>
            <div className="mb-8">
              <span className="text-4xl font-display font-bold text-brand-primary">2.5%</span>
              <span className="text-xl font-medium text-brand-muted ml-2">of CTC</span>
              <div className="text-sm font-bold text-brand-accent mt-2">+ $1000/year platform fee</div>
            </div>
            <Link to="/pricing" className="inline-flex items-center gap-2 font-black text-xs uppercase tracking-widest text-brand-primary hover:text-brand-accent transition-colors border-b-2 border-brand-primary hover:border-brand-accent pb-1">
              Learn More <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            whileHover={{ y: -10 }}
            className="p-12 bg-brand-primary rounded-[3rem] border border-white/10 shadow-2xl text-white relative overflow-hidden"
          >
            <div className="absolute top-8 right-8">
               <Sparkles className="w-8 h-8 text-brand-accent opacity-20" />
            </div>
            <h3 className="text-2xl font-display font-bold mb-4">AI Matched & Human Vetted</h3>
            <p className="text-brand-secondary opacity-80 mb-8 text-lg">AI-powered matching combined with human recruiter validation for higher precision hiring.</p>
            <div className="mb-8">
              <span className="text-4xl font-display font-bold text-brand-accent italic">8%</span>
              <span className="text-xl font-medium opacity-60 ml-2">of CTC</span>
              <div className="text-sm font-black text-brand-secondary mt-2">+ $1000/year platform fee</div>
            </div>
            <Link to="/pricing" className="inline-flex items-center gap-2 font-black text-xs uppercase tracking-widest text-brand-accent hover:brightness-125 transition-all border-b-2 border-brand-accent pb-1">
              Learn More <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>
        </div>

        <div className="text-center">
          <p className="text-sm font-bold text-brand-muted/40 uppercase tracking-widest italic">Includes access to the QuantumHire Hiring Workspace</p>
        </div>
      </div>
    </section>
  );
};
